module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "jsoneditor-vue"
  }), _vm._v(" "), (_vm.showBtns !== false) ? _c('div', {
    staticClass: "jsoneditor-btns"
  }, [_c('button', {
    staticClass: "json-save-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.error
    },
    on: {
      "click": function($event) {
        _vm.onSave()
      }
    }
  }, [_vm._v("保存")])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-64d80511", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64d80511"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-json-editor/vue-json-editor.vue
// module id = 1570
// module chunks = 1